import axios from 'axios'
import { toISOString, verifyIfCanStringify } from '../../../utils/utils'

export const getSettings = async () => {
  const { data } = await axios.get('/manager/data/jsonParameters?app=KIOSCO')
  return data
}

export const getProcedures = async (qs: Record<string, string>) => {
  const queries = new URLSearchParams(qs)
  const axiosUrl = '/manager/procedures'
  const { data } = await axios.get(`${axiosUrl}?${queries}`)
  return data.success ? data.response : []
}

export const cancelProcedures = async (request: Record<string, any>) => {
  const fetchUrl = `/manager/models/documentations`
  return await axios.put(fetchUrl, request)
}

export const saveIntegrationLogs = async (information: Record<string, any>) => {
  const fetchUrl = `/manager/data/integrationLogs`
  const date = toISOString(new Date())
  const request = {
    didId: information?.didId || null,
    eventName: information?.event,
    request:
      (verifyIfCanStringify(information?.request) ? JSON.stringify(information?.request) : information?.request) ?? '',
    response:
      (verifyIfCanStringify(information?.response) ? JSON.stringify(information?.response) : information?.response) ??
      '',
    httpStatusCode: information?.code || '',
    statusCode: information?.code || '',
    success: 'false',
    url: information?.config?.url || '',
    requestDate: date,
    responseDate: date,
    creationUsrId: information?.user || '',
    originService: 'DIG-KIOSK-FRONTEND'
  }
  try {
    await axios.post(fetchUrl, request)
  } catch (error) {
    console.log('No se pudo guardar en la integrationLogs', request)
  }
}
